import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DatePickerComponent from '../../components/DatePickerComponent';
import TextFieldComponent from '../../components/TextFieldComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, storeFilter, staffNumberFilter) => {
  let storeCodeFilterObj = {
    member: "TimePeriodSummary.shipFromStoreCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  let staffNumberFilterObj = {
    member: "InternalAppOperators.staffNumber",
    operator: "contains",
    values: [staffNumberFilter]
  }

  if (staffNumberFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(staffNumberFilterObj)
    }
  }

  return query
}

const PerPersionSpendingByStaffQuery = (storeFilter, startDateFilter, endDateFilter, staffNumberFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.staffStatisticsPage.name'),
    tableHeaders: {
      "InternalAppOperators.staffNumber": { name: t('page.fnb.staffStatisticsPage.tableHeader.staffNumber'), type: 'string'},
      "InternalAppOperators.firstName": { name: t('page.fnb.staffStatisticsPage.tableHeader.firstName'), type: 'string'},
      "InternalAppOperators.lastName": { name: t('page.fnb.staffStatisticsPage.tableHeader.lastName'), type: 'string'},
      "TimePeriodSummary.perPersonSpending": { name: t('page.fnb.staffStatisticsPage.tableHeader.perPersonSpending'), type: 'number'},
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'per_persion_spending_by_staff_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.timePeriodSummary.PerPersionSpendingByStaff.query,
    "timeDimensions": [
      {
        "dimension": "TimePeriodSummary.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, staffNumberFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const StaffStatisticsPage = () => {
  const { t } = useTranslation();
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  const [ staffNumberFilter, setStaffNumberFilter ] = useState('');
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = PerPersionSpendingByStaffQuery(storeFilter, startDateFilter, endDateFilter, staffNumberFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.staffStatistics')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.staffStatisticsPage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DatePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} pageChangerArr={[setPage]} 
        dateLabel={t('page.fnb.staffStatisticsPage.filter.orderCompletedAt.date')}/>
      <TextFieldComponent id={"staff_number_filter"} state={staffNumberFilter} pageChangerArr={[setPage]} 
          stateChanger={setStaffNumberFilter} textLabel={t('page.fnb.staffStatisticsPage.filter.staffNumber')}/>
    </Dashboard>,
    <Dashboard>
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default StaffStatisticsPage;